export const contentTableConfig = {
  propList: [
    { prop: 'custType', label: '客户分类', width: '60', slotName: 'custType', fixed: true},
    { prop: 'exploitAccount', label: '开发账号', width: '120', fixed: true},
    { prop: 'custName', label: '客户昵称/名字', width: '120', fixed: true },
    { prop: 'nineInformations', label: '九大资讯必须要填写详细\n' +
        '包含持仓股票代码\n' +
        '空闲时间', width: '200' },
    { prop: 'signExperience', label: '签约经历\n' +
        '（有或者无）', width: '100' },
    { prop: 'lifeAndWork', label: '了解客户的生活工作细节点\n' +
        '可以在后期关心客户，让客户感觉体贴', width: '200' },
    { prop: 'todayTrackCondition', label: '今日跟踪情况（投教）\n' +
        '（当下存在的问题、抗拒点、痛点、跟踪进度 等）\n' +
        '今天是否互动、几天未说话', width: '200' },
    { prop: 'tmrTrackPlan', label: '明日跟踪标准\n' +
        '（投教+经理）', width: '200' },
    { prop: 'amountQuotedAndEstimatedTxTime', label: '报价金额/版本\n' +
        '预计成交时间', width: '150' },
    { prop: 'empName', label: '员工', width: '100' },
    { prop: 'deptName', label: '部门', width: '100' },
    { label: '操作', width: '180', slotName: 'handler', fixed:'right'}
  ],
  showSelectColumn: true
}
